var React = require('react');

function TabletAndroid (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 384v80a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48v-80zm288 68a12 12 0 0 1-12 12H172a12 12 0 0 1-12-12v-8a12 12 0 0 1 12-12h104a12 12 0 0 1 12 12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 384V48A48 48 0 0 1 48 0h352a48 48 0 0 1 48 48v336z","className":"fa-primary","key":2})]);
}

TabletAndroid.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = TabletAndroid;

TabletAndroid.default = TabletAndroid;
